export enum BROADCAST_NOTIFICATION_TYPE {
  JOB_MODULE_RUNNING = "job-module-running",
  JOB_MODULE_COMPLETED = "job-module-completed",
  JOB_MODULE_FAILED = "job-module-failed",
  ASYNC_DELETE_FAILED = "async-delete-failed",
  ASYNC_DELETE_SUCCESS = "async-delete-success",
  OBSERVATION_COMMENTED = "observation-commented",
}
